import { FileClient } from "clients/rest";

export type B060030Request = { kumitatelisthakozumiKbn: string } & Partial<{
  shukayoteiYmdFrom: string;
  shukayoteiYmdTo: string;
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  kakoshubetsuCdFrom: string;
  kakoshubetsuCdTo: string;
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  nonyuCdFrom: string;
  nonyushitenCdFrom: string;
  nonyuCdTo: string;
  nonyushitenCdTo: string;
}>;

// 印刷処理
export const B060030Print = (props: B060030Request) => {
  return FileClient.put("b060030/print", props);
};
